import {
    AlertTriangle,
    PhoneOff,
} from "lucide-react";
import { Button, Select, message } from "antd";
import { useEffect, useState } from "react";

interface Props {
    /** Danh sách tùy chọn kết quả cuộc gọi trả về từ API chi tiết khách hàng */
    options?: { id: number; text: string }[];
    /** Kết quả cuộc gọi gần nhất đã lưu */
    value?: number | null;
    /** Lưu lại kết quả cuộc gọi (param last_call_result) */
    onReport?: (lastCallResult: number) => Promise<void>;
}

export default function CallReportFail({ options = [], value, onReport }: Props) {
    const [selected, setSelected] = useState<number | undefined>(value ?? undefined);
    const [saving, setSaving] = useState(false);

    // Đồng bộ theo giá trị đã lưu / khi đổi khách hàng
    useEffect(() => {
        setSelected(value ?? undefined);
    }, [value]);

    const selectOptions = options.map((o) => ({ label: o.text, value: o.id }));

    const handleReport = async () => {
        if (selected == null) {
            message.warning("Vui lòng chọn lý do");
            return;
        }
        if (!onReport) return;
        setSaving(true);
        try {
            await onReport(selected);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <div className="mt-3 font-medium text-gray-600 dark:text-gray-400">
                Báo cáo cuộc gọi (Telesale)
            </div>
            <div className="border border-[#e5e7eb] rounded-lg bg-white dark:bg-[#1f1f1f] mt-3">
                {/* Content */}
                <div className="p-3">

                    <div className="flex items-center gap-2 mb-3">
                        <PhoneOff
                            size={16}
                            className="text-[#6b7280]"
                        />

                        <span className="font-semibold text-[14px] text-000000e0 uppercase">
                            Tự báo cáo cuộc gọi thất bại
                        </span>
                    </div>

                    <div className="flex gap-2">

                        <Select
                            className="flex-1"
                            placeholder="Chọn lý do"
                            value={selected}
                            onChange={(val) => setSelected(val)}
                            options={selectOptions}
                        />

                        <Button
                            danger
                            type="primary"
                            icon={<AlertTriangle size={14} />}
                            loading={saving}
                            onClick={handleReport}
                        >
                            Báo cuộc gọi lỗi
                        </Button>

                    </div>

                </div>

            </div>
        </>

    );
}
